import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Button, Stack, Typography } from "@mui/material";

import { AmountInCustomerCurrency } from "../AmountInCustomerCurrency";
import HomePageCard from "../HomePageCard";
import { LoadingCard } from "../LoadingCard";

type InsightsCardProps = {
  insightsRisk: number;
  loading: boolean;
};

export const InsightsCard = ({ insightsRisk, loading }: InsightsCardProps) => {
  const history = useHistory();

  if (loading) {
    return <LoadingCard title="Insights awaiting action" />;
  }

  return (
    <HomePageCard title="Insights awaiting action">
      <Stack sx={{ p: 3, height: 161 }} justifyContent="space-between">
        <Stack sx={{ alignItems: "flex-start", mt: 2 }} spacing={2}>
          <Typography sx={{ fontSize: 44, fontWeight: 500 }}>
            <AmountInCustomerCurrency amount={insightsRisk} />
          </Typography>
          {insightsRisk > 0 && (
            <Typography variant="caption" sx={{ color: "error.main", ml: 1, display: "flex", alignItems: "center" }}>
              <WarningAmberIcon sx={{ width: 12, height: 12, color: "error.main", mr: 0.25 }} /> Cloud costs at risk
            </Typography>
          )}
        </Stack>
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 2, width: "fit-content" }}
          data-cy="cloud-waste-insights-btn"
          endIcon={<ArrowForwardIcon />}
          onClick={() => {
            history.push("./optimize/insights");
          }}
        >
          Review and take action
        </Button>
      </Stack>
    </HomePageCard>
  );
};
